import React from "react";
import CoverOverlapCard from "./CoverOverlapCard";

interface IProps {
  children: React.ReactNode;
  imageSrc: string;
  cardPlacement?: "left" | "right";
  className: string;
}

function Cover({ children, imageSrc, cardPlacement = "right", className }: IProps) {
  return (
    <div
      className={`flex h-[450px] w-full items-center rounded-2xl  border-2 border-white border-opacity-20 bg-cover bg-center ${
        cardPlacement === "left" ? "justify-start" : "justify-end"
      } pl-20 pr-14 ${className} `}
      style={{ backgroundImage: `url('${imageSrc}')` }}
    >
      {children}
    </div>
  );
}

Cover.Card = CoverOverlapCard;

export default Cover;

Cover.defaultProps = {
  cardPlacement: "right",
};
